import React, { useEffect, useState } from "react"; 
import { useParams } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "../Component/Baseurl"; 

const Agenda = ({eventUniqueId}) => {
 
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (eventUniqueId) {
      axios
        .get(`${BASE_URL}getSessionsWithAgendas/${eventUniqueId}`)
        .then((response) => {

            console.log("response agenda",response);
          if (response.data.success) {
            setSessions(response.data.sessions);
          }
        })
        .catch((err) => console.error("Error fetching agenda:", err))
        .finally(() => setLoading(false));
    }
  }, [eventUniqueId]);

  return (
    <>
      
     
        {loading ? (
          <p className="loading-text">Loading...</p>
        ) : (
          sessions.map((session) => (
            <div className="session-block" key={session.id}>
              <h3 className="session-name">{session.session_name}</h3>
              <p className="session-date">Date: {session.event_date}</p>
              <table className="agenda-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Time</th>
                    <th>Topic</th>
                    <th>Speaker</th>
                  </tr>
                </thead>
                <tbody>
                  {session.agendas.map((agenda, idx) => (
                    <tr key={agenda.id}>
                      <td>{idx + 1}</td>
                      <td>
                        {agenda.start_time} - {agenda.end_time}
                      </td>
                      <td>{agenda.agenda_topic}</td>
                      <td>{agenda.agenda_speaker}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))
        )}
      
    </>
  );
  
};

export default Agenda;
